import * as Types from '../../../../__generated__/base.gql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type WholeSyncableImagingInstanceFragment = { readonly __typename?: 'SyncableImagingInstance', readonly id: string, readonly imagingStudyAccessionNumber: string, readonly dicomStudyId?: string | null, readonly externalId: string, readonly previewS3Key: string, readonly thumbnailS3Key: string, readonly elephantPatientId?: string | null, readonly dicomPreset?: string | null, readonly physicalDeltaMm?: number | null, readonly numberOfFrames?: number | null, readonly frameRate?: number | null, readonly cineStatus?: Types.CineStatus | null, readonly cineS3Key?: string | null, readonly cineDurationMs?: number | null, readonly cineSizeBytes?: number | null, readonly deviceManufacturer?: string | null, readonly deviceModelName?: string | null, readonly meta: { readonly __typename?: 'SyncableMeta', readonly createdAt: string, readonly updatedAt: string, readonly createdByUserId: string, readonly updatedByUserId: string, readonly deleted: boolean } };

export type ImagingInstancePullQueryVariables = Types.Exact<{
  input: Types.PullImagingInstanceInput;
}>;


export type ImagingInstancePullQuery = { readonly __typename?: 'Query', readonly pullImagingInstance: { readonly __typename?: 'PullImagingInstanceResponse', readonly documents: ReadonlyArray<{ readonly __typename?: 'SyncableImagingInstance', readonly id: string, readonly imagingStudyAccessionNumber: string, readonly dicomStudyId?: string | null, readonly externalId: string, readonly previewS3Key: string, readonly thumbnailS3Key: string, readonly elephantPatientId?: string | null, readonly dicomPreset?: string | null, readonly physicalDeltaMm?: number | null, readonly numberOfFrames?: number | null, readonly frameRate?: number | null, readonly cineStatus?: Types.CineStatus | null, readonly cineS3Key?: string | null, readonly cineDurationMs?: number | null, readonly cineSizeBytes?: number | null, readonly deviceManufacturer?: string | null, readonly deviceModelName?: string | null, readonly meta: { readonly __typename?: 'SyncableMeta', readonly createdAt: string, readonly updatedAt: string, readonly createdByUserId: string, readonly updatedByUserId: string, readonly deleted: boolean } }> } };

export const WholeSyncableImagingInstanceFragmentDoc = gql`
    fragment WholeSyncableImagingInstance on SyncableImagingInstance {
  id
  imagingStudyAccessionNumber
  dicomStudyId
  externalId
  previewS3Key
  thumbnailS3Key
  elephantPatientId
  dicomPreset
  physicalDeltaMm
  numberOfFrames
  frameRate
  cineStatus
  cineS3Key
  cineDurationMs
  cineSizeBytes
  deviceManufacturer
  deviceModelName
  meta {
    createdAt
    updatedAt
    createdByUserId
    updatedByUserId
    deleted
  }
}
    `;
export const ImagingInstancePullDocument = gql`
    query ImagingInstancePull($input: PullImagingInstanceInput!) {
  pullImagingInstance(input: $input) {
    documents {
      ...WholeSyncableImagingInstance
    }
  }
}
    ${WholeSyncableImagingInstanceFragmentDoc}`;

/**
 * __useImagingInstancePullQuery__
 *
 * To run a query within a React component, call `useImagingInstancePullQuery` and pass it any options that fit your needs.
 * When your component renders, `useImagingInstancePullQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useImagingInstancePullQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useImagingInstancePullQuery(baseOptions: Apollo.QueryHookOptions<ImagingInstancePullQuery, ImagingInstancePullQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ImagingInstancePullQuery, ImagingInstancePullQueryVariables>(ImagingInstancePullDocument, options);
      }
export function useImagingInstancePullLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ImagingInstancePullQuery, ImagingInstancePullQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ImagingInstancePullQuery, ImagingInstancePullQueryVariables>(ImagingInstancePullDocument, options);
        }
export type ImagingInstancePullQueryHookResult = ReturnType<typeof useImagingInstancePullQuery>;
export type ImagingInstancePullLazyQueryHookResult = ReturnType<typeof useImagingInstancePullLazyQuery>;
export type ImagingInstancePullQueryResult = Apollo.QueryResult<ImagingInstancePullQuery, ImagingInstancePullQueryVariables>;